import topics from "./topics";
import posts from "./posts";

const allStubs = { ...topics, ...posts };

export default allStubs;
